export default __webpack_public_path__ + "static/media/8.721feae3.png";